import {
  GET_PACKAGE_DATA,
  LOAD_MORE_PACKAGE_DATA,
  SEARCH_PACKAGE_DATA,

} from "../types";
import axios from "axios";
import { normalizePackageItem, combinePackageItems } from "../../../utils/packageItems";
import {firebase} from '../../../firebase/initFirebase'
import moment from 'moment'
import {store} from '../../store'
import { message} from 'antd';

export const getPackageData = (props) => {
  return async (dispatch) => {
    var reduxState = store.getState()
    var userRole = reduxState.auth.user.role
    var useremail = reduxState.auth.user.email   
    var userLocation = reduxState.auth.user.branch
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection('packages') 
      // console.log(props)
    
      dataRef = dataRef.orderBy("created_at","desc")
      if(props.packageStatus){
        dataRef = dataRef.where("status", "==", props.packageStatus)        
      }
      if(userRole !== 'admin' && userRole !== 'warehouse' && userRole !== 'manager'){
    
        dataRef = dataRef.where("destination", "==", userLocation)   
      }

 
      // if(props.searchText){
      //   dataRef = dataRef.orderBy('name').startAt(props.searchText).endAt(props.searchText + '\uf8ff')
      // }
      // if(props.filters){
      //   if(props.filters.length > 0){
      //     props.filters.map(item=>{
      //       console.log(item)
      //       dataRef = dataRef.orderBy(item.dataIndex).startAt(item.value).endAt(item.value + '\uf8ff')
      //     })
      //   }       
      // }

      dataRef = dataRef.limit(40)
    
      var documentSnapshots = await dataRef.get()
      var docs = documentSnapshots.docs
      var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length-1];
      var dataArray =[]

      await Promise.all(docs.map(async (packageItem) => {    
        var newOrder={
            key:packageItem.id,
            id:packageItem.id,
            ...packageItem.data()
        }
        var dataRefItems = Firestore.collection('packages').doc(packageItem.id).collection('items')
        var documentSnapshots2 = await dataRefItems.get()
        var docs2 = documentSnapshots2.docs
        var newItems = []
  
        await Promise.all(docs2.map(async (item) => {  
       
          var bago={
            key:item.id,
            id:item.id,
            ...item.data()
          }  
          if(bago.product){
            var itemref = Firestore.collection('products').doc(bago.product)
            var newd = await itemref.get()
           
            if(newd.data()){
              var data3 = newd.data()
              var localavailable = 0
              var destinationavailable = 0
           
              if(data3[`${userLocation}_count`]){
                localavailable = data3[`${userLocation}_count`]
                
              }
              if(data3[`${newOrder.destination}_count`]){
                destinationavailable = data3[`${newOrder.destination}_count`]
              }
              bago['destination_available'] = destinationavailable              
              bago['location_available'] = localavailable
              bago['regionalization'] = data3.regionalization
          

            }  
          }
          newItems.push(bago)
        }));
        newOrder['items'] = newItems 
        dataArray.push(newOrder)
      }));
      dispatch({ type: GET_PACKAGE_DATA, payload: {dataArray:dataArray, lastVisible:lastVisible, currentProps:props } }) 

      
  };
};

export const loadMorePackageData = () => {
  return async(dispatch) => {
    var reduxState = store.getState()
    var userRole = reduxState.auth.user.role
    var useremail = reduxState.auth.user.email
    var currentLastItem = reduxState.packages.lastVisible
    var userLocation = reduxState.auth.user.branch
    var currentProps = reduxState.packages.currentProps
    var Firestore = firebase.firestore();
    
    var dataRef = Firestore.collection(currentProps.apiurl) 

      dataRef = dataRef.orderBy("created_at","desc") 
          
    
      if(currentProps.packageStatus){
        dataRef = dataRef.where("status", "==", currentProps.packageStatus)        
      }
    
      if(userRole !== 'admin' && userRole !== 'warehouse' && userRole !== 'manager'){
        dataRef = dataRef.where("destination", "==", userLocation)   

      }

      if(currentLastItem){
        dataRef = dataRef.startAfter(currentLastItem)
              
      
        if(currentProps.searchText){
          dataRef = dataRef.where('name', '>=', currentProps.searchText).where('name', '<=', currentProps.searchText+ '\uf8ff')
        }

        dataRef = dataRef.limit(100)
 
        var documentSnapshots = await dataRef.get()
        var docs = documentSnapshots.docs
        if(docs){
          var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length-1];
          var dataArray =[]
          await Promise.all(docs.map(async (packageItem) => {    
            var newOrder={
                key:packageItem.id,
                id:packageItem.id,
                ...packageItem.data()
            }
            var dataRefItems = Firestore.collection('packages').doc(packageItem.id).collection('items')
            var documentSnapshots2 = await dataRefItems.get()
            var docs2 = documentSnapshots2.docs
            var newItems = []
            await Promise.all(docs2.map(async (item) => {    
            
              var bago={
                key:item.id,
                id:item.id,
                ...item.data()
              }  
              if(bago.product){
                var itemref = Firestore.collection('products').doc(bago.product)
                var newd = await itemref.get()
                if(newd.data()){
                  var data3 = newd.data()
                  var localavailable = 0
                  var destinationavailable = 0
             
                  if(data3[`${userLocation}_count`]){
                    localavailable = data3[`${userLocation}_count`]
                  }
                  if(data3[`${packageItem.destination}_count`]){
                    destinationavailable = data3[`${packageItem.destination}_count`]
                  }
                  bago['destination_available'] = destinationavailable              
                  bago['location_available'] = localavailable
                  bago['regionalization'] = data3.regionalization
                }  
              }
              newItems.push(bago)
            }));
            newOrder['items'] = newItems 
     
            dataArray.push(newOrder)
          }));
          if(lastVisible && currentLastItem !== lastVisible){

            dispatch({ type: LOAD_MORE_PACKAGE_DATA, payload: {dataArray:dataArray, lastVisible:lastVisible} })  
          }else{
            message.error('No More Orders To Load');
          }
        }else{
          message.error('No More Orders To Load');
        }
    }
  };
};



export const searchPackageData = (filter, data) => {
  return (dispatch) => {
    dispatch({
      type: SEARCH_PACKAGE_DATA,
      filter: filter,
      data: data,
    });
  };
};



export const retrievePackage = (ID) => {
  return async (dispatch) => {
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection('packages').doc(ID)
    var ItemsRef = Firestore.collection('packages').doc(ID).collection('items')
    var documentSnapshots = await dataRef.get()
    var mainpackage = documentSnapshots.data()
    var documentSnapshots2 = await ItemsRef.get()
    var itemdocs = documentSnapshots2.docs
    var newItems = []

    await Promise.all(itemdocs.map(async (itemx) => {    
      var newOrder={
          key:itemx.id,
          id:itemx.id,
          ...itemx.data()
      }
      var productRef = Firestore.collection('products').doc(newOrder.product)
      var documentSnapshots3 = await productRef.get()
      var prodData  = documentSnapshots3.data()
      newOrder['source'] = prodData
      newItems.push(newOrder)
    }))
    mainpackage['items'] = newItems
    mainpackage['id'] = documentSnapshots.id



    return(mainpackage)
   
  };
};

export const readyShip = (currentPack) => {
  return async (dispatch) => {
    var reduxState = store.getState()
    var Firestore = firebase.firestore();
    var userID = reduxState.auth.user.id
    var userName = reduxState.auth.user.name
    var userLocation = reduxState.auth.user.branch
    var userLocationName = reduxState.auth.user.branch_name

    var packageRef = Firestore.collection('packages').doc(currentPack.id)
    var ItemsRef = Firestore.collection('packages').doc(currentPack.id).collection('items')

    var prodRef = Firestore.collection('products')
    var inventoryRef = Firestore.collection('inventory')
    
    var exchangerateRef = Firestore.collection('config').doc('weightedexchangerate')
    var exchangerateSnapshot = await exchangerateRef.get()

    var exchangeitem = exchangerateSnapshot.data().value

    var dest = currentPack.destination

    var packdata = { 
      status: 'toShip', 
      packed_at: moment().format('YYYY-MM-DD HH:mm:ss'),      
      packed_by:userID,
      packed_name:userName,  
      exchange_rate:exchangeitem
    }
    console.log(packdata)
    var step1 = await packageRef.update(packdata,{merge: true})
    console.log('package toShip',step1)
    await Promise.all(currentPack.items.map(async (indx) => {    
 
      var newPackgeItem = {
        cost_peso : indx.source.cost_peso ? indx.source.cost_peso : 0,
        cost_rmb: indx.source.cost_rmb ? indx.source.cost_rmb : 0,
        cost_rmb: indx.source.cost_rmb ? indx.source.cost_rmb : 0,
        category: indx.source.category,
        category_name: indx.source.category_name,
        regionalization: indx.source.regionalization,
        cost_rmb_adjusted: indx.source.cost_rmb ? parseFloat(indx.source.cost_rmb) *1.05  : 0
      }
      
      var prodData ={
        updated_at: moment().format('YYYY-MM-DD HH:mm:ss'),
        updated_by: userID,
        updated_name:userName,
      }

      var inventoryID = `${userLocation}_${indx.product}`
      var InventoryData ={
        updated_at: moment().format('YYYY-MM-DD HH:mm:ss'),
        updated_by: userID,
        updated_name:userName,
        reason: 'packed',
        product:indx.product,
        product_name:indx.product_name,
        location:userLocation,
        location_name:userLocationName
      }

      var inventoryLogForm ={
        created_at: moment().format('YYYY-MM-DD HH:mm:ss'),
        reason:'packed',
        created_by:userID,
        created_name:userName,
      }
      // if(userLocation == dest){
    
      // }else{
        if(indx.source[`${userLocation}_count`]){
          prodData[`${userLocation}_count`] = parseFloat(indx.source[`${userLocation}_count`]) - parseFloat(indx.quantity)
          InventoryData['quantity'] = parseFloat(indx.source[`${userLocation}_count`]) - parseFloat(indx.quantity)
          inventoryLogForm['quantity'] = parseFloat(indx.source[`${userLocation}_count`]) - parseFloat(indx.quantity)
  
        }else{
          prodData[`${userLocation}_count`] = 0 - parseFloat(indx.quantity)
          InventoryData['quantity'] = 0 - parseFloat(indx.quantity)
          inventoryLogForm['quantity'] = 0 - parseFloat(indx.quantity)
  
        }  
      // }

      console.log(newPackgeItem,prodData,InventoryData,inventoryLogForm)
     
      var packageitemchange = await ItemsRef.doc(indx.id).set(newPackgeItem,{merge: true})
      var productChange = await prodRef.doc(indx.product).set(prodData,{merge: true})
      var inventoryChange = await inventoryRef.doc(inventoryID).set(InventoryData,{merge: true})
      var inventoryLogMake = await inventoryRef.doc(inventoryID).collection('inventory_log').doc().set({
        ...inventoryLogForm,
        product: indx.product,
        product_name: indx.product_name,
        location: userLocation,
        location_name: userLocationName,
        package_id: currentPack.id
      })


    }));   
    return('oks')
  };
};


export const completePackage = (currentPack) => {
  return async (dispatch) => {
    var reduxState = store.getState()
    var Firestore = firebase.firestore();
    var userID = reduxState.auth.user.id
    var userName = reduxState.auth.user.name
    var userLocation = reduxState.auth.user.branch
    var userLocationName = reduxState.auth.user.branch_name
    var dest = currentPack.destination
    var destName = currentPack.destination_name


    var packageRef = Firestore.collection('packages').doc(currentPack.id)
    var ItemsRef = Firestore.collection('packages').doc(currentPack.id).collection('items')

    var prodRef = Firestore.collection('products')
    var inventoryRef = Firestore.collection('inventory')

    var packdata = { 
      status: 'completed',
      received_at: moment().format('YYYY-MM-DD HH:mm:ss'),      
      received_by:userID,
      received_name:userName,  
    }
    if(userLocation == dest){
      var exchangerateRef = Firestore.collection('config').doc('weightedexchangerate')
      var exchangerateSnapshot = await exchangerateRef.get()

      var exchangeitem = exchangerateSnapshot.data().value
      packdata['exchange_rate']=exchangeitem
    }
  
  
    var step1 = await packageRef.update(packdata,{merge: true})
    var step2 =   await Promise.all(currentPack.items.map(async (indx) => {    
      
      var newPackgeItem = {
        cost_peso : indx.source.cost_peso ? indx.source.cost_peso : 0,
        cost_rmb: indx.source.cost_rmb ? indx.source.cost_rmb : 0,
        cost_rmb: indx.source.cost_rmb ? indx.source.cost_rmb : 0,
        regionalization: indx.source.regionalization,
        category: indx.source.category,
        category_name: indx.source.category_name,
        cost_rmb_adjusted: indx.source.cost_rmb ? parseFloat(indx.source.cost_rmb) *1.05  : 0
      }
      
      
      var prodData ={
        updated_at: moment().format('YYYY-MM-DD HH:mm:ss'),
        updated_by: userID,
        updated_name:userName,
      }

      var inventoryID = `${dest}_${indx.product}`
      var InventoryData ={
        updated_at: moment().format('YYYY-MM-DD HH:mm:ss'),
        updated_by: userID,
        updated_name:userName,
        reason: 'received',
        product:indx.product,
        product_name:indx.product_name,
        location:dest,
        location_name:destName
      }

      var inventoryLogForm ={
        created_at: moment().format('YYYY-MM-DD HH:mm:ss'),
        reason:'received',
        created_by:userID,
        created_name:userName,
      }

      if(indx.source[`${dest}_count`]){
        prodData[`${dest}_count`] = parseFloat(indx.source[`${dest}_count`]) + parseFloat(indx.quantity)
        InventoryData['quantity'] = parseFloat(indx.source[`${dest}_count`]) + parseFloat(indx.quantity)
        inventoryLogForm['quantity'] = parseFloat(indx.source[`${dest}_count`]) + parseFloat(indx.quantity)

      }else{
        prodData[`${dest}_count`] = parseFloat(indx.quantity)
        InventoryData['quantity'] = parseFloat(indx.quantity)
        inventoryLogForm['quantity'] = parseFloat(indx.quantity)

      }   


      if(userLocation == dest){
        var packageitemchange = await ItemsRef.doc(indx.id).set(newPackgeItem,{merge: true})
      }
      var productChange = await prodRef.doc(indx.product).set(prodData,{merge: true})
      var inventoryChange = await inventoryRef.doc(inventoryID).set(InventoryData,{merge: true})
      var inventoryLogMake = await inventoryRef.doc(inventoryID).collection('inventory_log').doc().set(inventoryLogForm)


    }));   
    return('oks')
  };
};


export const completeDirectPackage = (currentPack) => {
  return async (dispatch) => {
    var reduxState = store.getState()
    var Firestore = firebase.firestore();
    var userID = reduxState.auth.user.id
    var userName = reduxState.auth.user.name
    var userLocation = reduxState.auth.user.branch
    var userLocationName = reduxState.auth.user.branch_name
    var dest = currentPack.destination
    var destName = currentPack.destination_name


    var packageRef = Firestore.collection('packages').doc(currentPack.id)
    var ItemsRef = Firestore.collection('packages').doc(currentPack.id).collection('items')

    var prodRef = Firestore.collection('products')
    var inventoryRef = Firestore.collection('inventory')

    var packdata = { 
      status: 'completed',
      received_at: moment().format('YYYY-MM-DD HH:mm:ss'),      
      received_by:userID,
      received_name:userName,  
    }
    if(userLocation == dest){
      var exchangerateRef = Firestore.collection('config').doc('weightedexchangerate')
      var exchangerateSnapshot = await exchangerateRef.get()

      var exchangeitem = exchangerateSnapshot.data().value
      packdata['exchange_rate']=exchangeitem
    }
  
  
    var step1 = await packageRef.update(packdata,{merge: true})
    var step2 =   await Promise.all(currentPack.items.map(async (indx) => {    
      
      var newPackgeItem = {
        cost_peso : indx.source.cost_peso ? indx.source.cost_peso : 0,
        cost_rmb: indx.source.cost_rmb ? indx.source.cost_rmb : 0,
        cost_rmb: indx.source.cost_rmb ? indx.source.cost_rmb : 0,
        regionalization: indx.source.regionalization,
        category: indx.source.category,
        category_name: indx.source.category_name,
        cost_rmb_adjusted: indx.source.cost_rmb ? parseFloat(indx.source.cost_rmb) *1.05  : 0,
        quantity: indx.received_quantity, 
        quantity_discrepancy:parseFloat(indx.ordered_quantity) - parseFloat(indx.received_quantity),
      }
      
      
      var prodData ={
        updated_at: moment().format('YYYY-MM-DD HH:mm:ss'),
        updated_by: userID,
        updated_name:userName,
      }

      var inventoryID = `${dest}_${indx.product}`
      var InventoryData ={
        updated_at: moment().format('YYYY-MM-DD HH:mm:ss'),
        updated_by: userID,
        updated_name:userName,
        reason: 'received',
        product:indx.product,
        product_name:indx.product_name,
        location:dest,
        location_name:destName
      }

      var inventoryLogForm ={
        created_at: moment().format('YYYY-MM-DD HH:mm:ss'),
        reason:'received',
        created_by:userID,
        created_name:userName,
      }

      if(indx.source[`${dest}_count`]){
        prodData[`${dest}_count`] = parseFloat(indx.source[`${dest}_count`]) + parseFloat(indx.received_quantity)
        InventoryData['quantity'] = parseFloat(indx.source[`${dest}_count`]) + parseFloat(indx.received_quantity)
        inventoryLogForm['quantity'] = parseFloat(indx.source[`${dest}_count`]) + parseFloat(indx.received_quantity)

      }else{
        prodData[`${dest}_count`] = parseFloat(indx.received_quantity)
        InventoryData['quantity'] = parseFloat(indx.received_quantity)
        inventoryLogForm['quantity'] = parseFloat(indx.received_quantity)

      }   


      if(userLocation == dest){
        var packageitemchange = await ItemsRef.doc(indx.id).set(newPackgeItem,{merge: true})
      }
      var productChange = await prodRef.doc(indx.product).set(prodData,{merge: true})
      var inventoryChange = await inventoryRef.doc(inventoryID).set(InventoryData,{merge: true})
      var inventoryLogMake = await inventoryRef.doc(inventoryID).collection('inventory_log').doc().set(inventoryLogForm)


    }));   
    return('oks')
  };
};

export const addPackage = (data, apiurl) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection(apiurl)

    return(dataRef.doc().set(data))
  };
};

export const editPackage = (data, apiurl, id) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var OrdersRef = Firestore.collection(apiurl)

    return OrdersRef.doc(id).update(data)
  };
};

export const setPackage = (data,id) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection('packages')
    return(dataRef.doc(id).set(data,{merge: true}))
  };
};

export const updatePackage = (data, apiurl, id) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection(apiurl)
    return(dataRef.doc(id).update(data,{merge: true}))
  };
};

export const deletePackage = (apiurl, id) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var OrdersRef = Firestore.collection(apiurl)

    return OrdersRef.doc(id).delete()
  };
};



// Parent revisions serialize item edits and merges, including changes to item membership.
const revisionOf = (snapshot) => snapshot.data()?.items_revision || 0;

export const mergePackage = (removePackage, keepPackage) => async () => {
  if (removePackage.id === keepPackage.id) throw new Error("Select different packages.");
  const db = firebase.firestore();
  const user = store.getState().auth.user;
  const source = db.collection("packages").doc(removePackage.id);
  const target = db.collection("packages").doc(keepPackage.id);
  const parents = await Promise.all([source.get(), target.get()]);
  const lists = await Promise.all([source.collection("items").get(), target.collection("items").get()]);
  // Keep source items intact for audit and recovery.
  if (lists[0].size + lists[1].size + 2 > 500) throw new Error("Package is too large to merge atomically.");
  await db.runTransaction(async (tx) => {
    const sourceDoc = await tx.get(source);
    const targetDoc = await tx.get(target);
    if (!sourceDoc.exists || !targetDoc.exists) throw new Error("Package no longer exists.");
    const from = sourceDoc.data();
    const to = targetDoc.data();
    if (from.status !== "pending" || to.status !== "pending" ||
        from.destination !== to.destination || !!from.is_direct !== !!to.is_direct) {
      throw new Error("Only pending packages with the same destination and shipping type can be merged.");
    }
    if (revisionOf(sourceDoc) !== revisionOf(parents[0]) || revisionOf(targetDoc) !== revisionOf(parents[1])) {
      throw new Error("Package items changed. Refresh and try again.");
    }
    const snapshots = [];
    for (const list of lists) {
      const items = [];
      for (const doc of list.docs) {
        const fresh = await tx.get(doc.ref);
        if (!fresh.exists) throw new Error("Package items changed. Refresh and try again.");
        items.push(fresh.data());
      }
      snapshots.push(items);
    }
    const combined = combinePackageItems([...snapshots[1], ...snapshots[0]]);
    if (lists[1].size + combined.length + 2 > 500) throw new Error("Package is too large to merge atomically.");
    lists[1].docs.forEach((doc) => tx.delete(doc.ref));
    combined.forEach((item) => tx.set(target.collection("items").doc(), item));
    tx.update(target, { items_revision: revisionOf(targetDoc) + 1 });
    tx.update(source, {
      status: "merged", merged_into: target.id,
      merged_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      merged_by: user.id, merged_name: user.name,
      items_revision: revisionOf(sourceDoc) + 1,
    });
  });
  return "merge done";
};

export const createPackage = (destinationdata) => async () => {
  const db = firebase.firestore();
  const user = store.getState().auth.user;
  const cartRef = db.collection("users").doc(user.id).collection("cart");
  const snapshot = await cartRef.get();
  if (snapshot.empty) throw new Error("Cart is empty.");
  if (snapshot.size * 2 + 2 > 500) throw new Error("Cart is too large to submit atomically.");
  const regularRef = db.collection("packages").doc();
  const directRef = db.collection("packages").doc();
  return db.runTransaction(async (tx) => {
    const groups = { regular: [], direct: [] };
    const consumed = [];
    for (const doc of snapshot.docs) {
      const fresh = await tx.get(doc.ref);
      if (!fresh.exists) continue;
      const data = fresh.data();
      const item = normalizePackageItem(data);
      const direct = Array.isArray(data.direct_ship) && data.direct_ship.includes(destinationdata.destination);
      groups[direct ? "direct" : "regular"].push(item);
      consumed.push(doc.ref);
    }
    if (!consumed.length) throw new Error("Cart has already been submitted.");
    const results = [];
    for (const [kind, items] of Object.entries(groups)) {
      if (!items.length) continue;
      const direct = kind === "direct";
      const ref = direct ? directRef : regularRef;
      const status = direct && ["admin", "manager"].includes(user.role) ? "shipping" : destinationdata.status;
      tx.set(ref, {
        ...destinationdata, status, is_direct: direct, items_revision: 0,
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
        created_by: user.id, created_name: user.name,
      });
      items.forEach((item) => tx.set(ref.collection("items").doc(), direct ? { ...item, ordered_quantity: item.quantity } : item));
      results.push({ id: ref.id, status, is_direct: direct, items });
    }
    consumed.forEach((ref) => tx.delete(ref));
    return results;
  });
};

export const createPackageFromItems = (destinationdata, items) => async () => {
  const db = firebase.firestore();
  const user = store.getState().auth.user;
  const packageItems = (items || []).map((item) => normalizePackageItem({ ...item, product: item.product || item.id }));
  if (!packageItems.length) throw new Error("No package items to create.");
  if (packageItems.length + 1 > 500) throw new Error("Package is too large to create atomically.");
  const ref = db.collection("packages").doc();
  const batch = db.batch();
  batch.set(ref, {
    ...destinationdata, created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
    created_by: user.id, created_name: user.name, is_direct: false, items_revision: 0,
  });
  packageItems.forEach((item) => batch.set(ref.collection("items").doc(), item));
  await batch.commit();
  return ref.id;
};

export const approvePackage = (record, id) => async () => {
  const user = store.getState().auth.user;
  const db = firebase.firestore();
  const ref = db.collection("packages").doc(id);
  return db.runTransaction(async (tx) => {
    const snapshot = await tx.get(ref);
    if (!snapshot.exists || snapshot.data().status !== "pending") {
      throw new Error("Package is no longer pending. Refresh and try again.");
    }
    tx.update(ref, {
      approved_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      approved_by: user.id, approved_by_name: user.name,
      status: snapshot.data().is_direct ? "shipping" : "toPack",
    });
  });
};

export const backtoPendingPackage = (id) => {
  return (dispatch) => {
    var reduxState = store.getState()
    var userID = reduxState.auth.user.id
    var userName = reduxState.auth.user.name
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection('packages')
    var data ={  
      status:'pending'
    }
    return(dataRef.doc(id).update(data,{merge: true}))
  };
};

const mutatePackageItem = (data, packID, id, remove = false) => async () => {
  const db = firebase.firestore();
  const parent = db.collection("packages").doc(packID);
  const ref = parent.collection("items").doc(id);
  return db.runTransaction(async (tx) => {
    const pack = await tx.get(parent);
    const item = await tx.get(ref);
    if (!pack.exists || pack.data().status === "merged") throw new Error("Package is no longer editable.");
    if (!item.exists) throw new Error("Package item no longer exists.");
    if (remove) tx.delete(ref);
    else tx.set(ref, { ...data, unit: data.unit || item.data().unit || "unit" }, { merge: true });
    tx.update(parent, { items_revision: revisionOf(pack) + 1 });
  });
};

export const editPackageItem = (data, packID, id) => mutatePackageItem(data, packID, id);
export const deletePackagetItem = (packID, id) => mutatePackageItem(null, packID, id, true);

export const deleteByPackagesItembyProductID = (packages,prodID) => {
  return async (dispatch) => {
    var reduxState = store.getState()
    var userId = reduxState.auth.user.id
    var Firestore = firebase.firestore();
    await Promise.all(packages.map(async (pack) => {     
      var packItemRef = Firestore.collection('packages').doc(pack.id).collection('items')
      packItemRef = packItemRef.where("product", "==", prodID)   
      var documentSnapshots = await packItemRef.get()
      var docs = documentSnapshots.docs
      await Promise.all(docs.map(async (packageItem) => {    
        return dispatch(deletePackagetItem(pack.id, packageItem.id))
      }))
    
    }))

  
 
  
  };
};

export const attachSource = (consolidata) => {
  return async (dispatch) => {
    var Firestore = firebase.firestore();
    var exchangerateRef = Firestore.collection('config').doc('weightedexchangerate')
    var exchangerateSnapshot = await exchangerateRef.get()
    // console.log( exchangerateSnapshot.data())
    var exchangeitem = exchangerateSnapshot.data().value
 
 
    var newItems = []

    await Promise.all(consolidata.map(async (itemx) => {    
 
      var productRef = Firestore.collection('products').doc(itemx.product)
      var documentSnapshots3 = await productRef.get()
      var prodData  = documentSnapshots3.data()
  
      var newOrder={   
        ...prodData,
        exchangerate: exchangeitem,
        ...itemx,        
      }
      newItems.push(newOrder)
    }))

    return(newItems)
   
  };
};


export const fixbrockenpackages = (tofixpackages) => { 
  return async (dispatch) => {
    var reduxState = store.getState()
    var Firestore = firebase.firestore();
    var exchangerateRef = Firestore.collection('config').doc('weightedexchangerate')
    var exchangerateSnapshot = await exchangerateRef.get()
    var exchangeitem = exchangerateSnapshot.data().value

    for (let i = 0; i < tofixpackages.length; i++) {
      var currentPack = tofixpackages[i]


      var packageRef = Firestore.collection('packages').doc(currentPack.id)
      var ItemsRef = Firestore.collection('packages').doc(currentPack.id).collection('items')
      console.log(`fixing package:${currentPack.id}`)
      message.info(`fixing package:${currentPack.id}`)
      if(!currentPack.exchange_rate){
        var packdata = { 
          exchange_rate:exchangeitem
        }
        var step1 = await packageRef.update(packdata,{merge: true})
      }

    
        
      for (let x = 0; x < currentPack.items.length; x++) {
        var indx =  currentPack.items[x]
        if(indx.cost_peso == undefined || indx.cost_rmb_adjusted == undefined || indx.category == undefined){
          
          
          var productRef = Firestore.collection('products').doc(indx.product)
          var documentSnapshots3 = await productRef.get()
          var prodData  = documentSnapshots3.data()
          console.log(`${i}/${tofixpackages.length}  ===  ${x}/${currentPack.items.length}`)
          if(prodData){
            message.info(`fixing package Item:${currentPack.id} - ${indx.id}`)
        
            var newPackgeItem = {
              cost_peso : prodData.cost_peso ?prodData.cost_peso : 0,
              cost_rmb: prodData.cost_rmb ? prodData.cost_rmb : 0,
              cost_rmb: prodData.cost_rmb ? prodData.cost_rmb : 0,
              category: prodData.category,
              category_name: prodData.category_name,
              regionalization: prodData.regionalization,
              cost_rmb_adjusted: prodData.cost_rmb ? parseFloat(prodData.cost_rmb) *1.05  : 0
            }
            
            message.success(`FIXED package Item:${currentPack.id} - ${indx.id}`)
            var packageitemchange = await ItemsRef.doc(indx.id).set(newPackgeItem,{merge: true})  
          }else{       
            console.log(`broken product:${currentPack.id}/items/${indx.id}`)

            console.log(indx)
          }

        }
      }
    
    }
    return('oks')
  };
};


